import posthog from 'posthog-js';

const SHIFT_START_KEY = 'shift_start_time';

type UserInfo = {
  id?: string;
  username?: string;
};

export const trackShiftEnd = (user: UserInfo | null) => {
  try {
    const endTimestamp = new Date().toISOString();
    const startTimestamp = localStorage.getItem(SHIFT_START_KEY);
    
    if (startTimestamp) {
      const startTime = new Date(startTimestamp).getTime();
      const endTime = new Date(endTimestamp).getTime();
      const durationMs = endTime - startTime;
      const durationSeconds = Math.round(durationMs / 1000);
      const minutes = Math.floor(durationSeconds / 60);
      const seconds = durationSeconds % 60;
      
      posthog.capture('monitor_shift_end', {
        username: user?.username,
        user_id: user?.id,
        timestamp: endTimestamp,
        distinct_id: user?.id,
        shift_duration: `${minutes}m ${seconds}s`,
        shift_duration_seconds: durationSeconds,
        shift_start: startTimestamp,
        shift_end: endTimestamp,
      });
      
      localStorage.removeItem(SHIFT_START_KEY);
    } else {
      posthog.capture('monitor_shift_end', {
        username: user?.username,
        user_id: user?.id,
        timestamp: endTimestamp,
        distinct_id: user?.id,
      });
    }
  } catch (error) {
    console.error('Error tracking shift end:', error);
  }
};

export const trackShiftStart = (user: UserInfo | null) => {
  try {
    const timestamp = new Date().toISOString();
    localStorage.setItem(SHIFT_START_KEY, timestamp);
    
    posthog.capture('monitor_shift_start', {
      username: user?.username,
      user_id: user?.id,
      timestamp: timestamp,
      distinct_id: user?.id,
    });
  } catch (error) {
    console.error('Error tracking shift start:', error);
  }
};